export const PRESS_EMAIL = "mindbodyspirithygiene@gmail.com";
export const PRESS_EMAIL_SUBJECT = "Media Inquiry for Temple Franklin";
export const PRESS_NOTE = "When I was conducting interviews and running my shows in radio — fifteen years of it — it was important that my guest felt safe to share. It felt more like two people talking over coffee: deep conversation, vulnerable, educational and inspiring. My show had open dialogue, open communication, and the depth and length to provide that. That is still what I want from a conversation: room to inspire, to educate, and to feel safe sharing what I have learned.";

export const PRESS_EMAIL_BODY = [
  "Hi Temple,",
  "I’d like to invite you on [show or platform].",
  "———",
  "A note from Temple:",
  PRESS_NOTE,
  "———",
  "About your show:",
  "Audience size:",
  "Demographics — so I know who I am speaking to:",
  "Topic you’d like me to speak on:",
  "Audio or video:",
  "Proposed date and format:",
  "Your email:",
  "Your website:",
  "Thank you.",
].join("\n\n");

export const PRESS_MAILTO = `mailto:${PRESS_EMAIL}?subject=${encodeURIComponent(PRESS_EMAIL_SUBJECT)}&body=${encodeURIComponent(PRESS_EMAIL_BODY)}`;
